import * as brandColors from '../../../../../../../utils/brand-colors';

export default () => ({
  loadingGridItem: { textAlign: 'center' },
  detailsContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '.5em',
  },
  subtotalContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    marginTop: '1em',
    marginBottom: '.5em',
  },
  quantity: { width: 20 },
  label: { color: 'black' },
  description: {
    color: brandColors.grey[500],
    fontSize: 12,
    lineHeight: '14px',
  },
  labelContainer: {
    flex: 1,
    textAlign: 'left',
    marginLeft: '1em',
  },
  orderDetailsDivider: {
    marginTop: '1em',
    marginBottom: '1em',
  },
  totalUnitRate: {
    fontWeight: 500,
    fontSize: '1rem',
  },
  totalLabel: {
    fontWeight: 300,
    fontSize: '1rem',
  },
});
